import { Redirect, Route, useLocation } from 'react-router-dom';
import { AppRoute, ROUTES } from 'app/routes';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { rememberJobSeekerLocation, selectIsJobSeekerAuthenticated, selectJobSeeker } from 'features/job-seeker-auth';
import { checkIsAtLeastOneCommunityFullAdmin, checkIsAtLeastOneCommunityViewOnlyAdmin } from 'utils/job-seeker-on-behalf-of-organization-helper';
import { JobSeekerAppLayout } from 'layout/AppLayout';
import { MemberRoles, SignInSections } from 'features/types';

const JobSeekerPrivateRoute = (props: Omit<AppRoute, 'accountType'>) => {
  const { component: Component, allowedRoles, allowedCompanyStatuses, ...rest } = props;
  const jobSeeker = useAppSelector(selectJobSeeker);
  const isAuthenticated = useAppSelector(selectIsJobSeekerAuthenticated);
  const location = useLocation();
  const dispatch = useAppDispatch();

  const jobSeekerRoles: MemberRoles[] = [];
  if (allowedRoles && (allowedRoles.includes(MemberRoles.FullAdmin) || allowedRoles.includes(MemberRoles.ViewOnlyAdmin)) && jobSeeker) {
    if (allowedRoles.includes(MemberRoles.FullAdmin)) {
      const communityAdminRole = checkIsAtLeastOneCommunityFullAdmin(jobSeeker);
      if (communityAdminRole) jobSeekerRoles.push(MemberRoles.FullAdmin);
    }
    if (allowedRoles.includes(MemberRoles.ViewOnlyAdmin)) {
      const communityAdminRole = checkIsAtLeastOneCommunityViewOnlyAdmin(jobSeeker);
      if (communityAdminRole) jobSeekerRoles.push(MemberRoles.ViewOnlyAdmin);
    }
  }

  return (
    <Route
      {...rest}
      render={() => {
        if (!isAuthenticated) {
          dispatch(rememberJobSeekerLocation(location.pathname));
          return <Redirect to={ROUTES.SIGN_IN_DYNAMIC(SignInSections.JobSeekerSignIn)} />;
        }

        if (allowedRoles && allowedRoles.length && !jobSeekerRoles.some(role => allowedRoles.includes(role))) {
          return <Redirect to="/" />;
        }

        return (
          <JobSeekerAppLayout>
            <Component />
          </JobSeekerAppLayout>
        );
      }}
    />
  );
};

export default JobSeekerPrivateRoute;
